import ReconnectingWebSocket from 'reconnecting-websocket';

function setupWs(roomId) {
    console.log(`Setting up websocket connection for room ${roomId}`);

    let serverHostname = window.location.hostname;
    if (window.location.hostname === "localhost") {
        serverHostname += ":9999"; // Localhost is served on another port
    }

    let callbacks = {};
    const token = localStorage.getItem(`game-uuid-${roomId}`);
    const websocketScheme = document.location.protocol === "https:" ? "wss" : "ws";
    var ws = new ReconnectingWebSocket(`${websocketScheme}://${serverHostname}/api/ws?room=${roomId}&tok=${token}`);
    let hasEverConnected = false;
    ws.addEventListener('open', function (_ev) {
        if (hasEverConnected === false) {
            console.log("Connected to server");

            hasEverConnected = true;
            if (typeof callbacks.onFirstConnect === 'function') {
                callbacks.onFirstConnect(ws);
            }
        } else {
            console.log("Reconnected with server");

            // Reconnection
            if (typeof callbacks.onReconnect === 'function') {
                callbacks.onReconnect(ws);
            }
        }
    });

    ws.addEventListener('message', (ev) => {
        if (!ev.data) {
            return;
        }

        let parsedData = JSON.parse(ev.data);
        if (!parsedData || !parsedData.action) {
            return;
        }

        if (parsedData.action === 'ping') {
            ws.gsend({ action: 'pong' });
            return;
        }

        console.debug(`<< ${parsedData.action} | (${JSON.stringify(parsedData)})`);
        if (typeof callbacks.onMessage == 'function') {
            callbacks.onMessage(ws, parsedData);
        }
    });

    ws.addEventListener('close', (ev) => {
        if (ev.code === 4010) {
            console.log("Closed connection to server");
            ws.close();
            return; // We initiated the disconnection
        }

        if (ev.code === 4000) {
            console.log("Close connection request from server due to multi-connection");

            if (typeof callbacks.onCloseUntilReload == 'function') {
                callbacks.onCloseUntilReload(ws);
            }
            ws.close();
            return;
        }

        console.log("Lost connection to server, code ", ev.code);
        if (typeof callbacks.onClose == 'function') {
            callbacks.onClose(ws);
        }
    });

    ws.gsend = (msg) => {
        const msgStr = JSON.stringify(msg);
        ws.send(msgStr);
        console.debug(`>> ${msg.action} | (${msgStr})`);
    };

    ws.setCallback = (cbType, cb) => {
        callbacks[cbType] = cb;
    };

    return ws;
}

function getWs(roomId) {
    if (!roomId) {
        console.error("Trying to set up websocket for no room?");
        return null;
    }

    if (window.wsRoomId !== roomId && window.ws) {
        clearWs();
    }

    if (!window.ws) {
        window.wsRoomId = roomId;
        window.ws = setupWs(roomId);
    }

    return window.ws;
}


function clearWs() {
    console.log("Clearing WS");
    if (!window.ws) {
        return;
    }

    window.ws.close(4010);
    window.ws = null;
}

export { getWs, clearWs };
